import React from 'react';
import { Link } from 'react-router-dom';
import ChurchLogo from './ChurchLogo';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__top container">
        {/* Brand */}
        <div className="footer__col footer__col--brand">
          <div className="footer__logo">
            <ChurchLogo size={52} color="#C9A84C" />
            <span className="footer__logo-abbr">MIPRECCH</span>
          </div>
          <h3 className="footer__name">Première Église Chrétienne De La Chambre Haute De Saint-Marc</h3>
          <p className="footer__tagline">
            Venez comme vous êtes,<br />repartez transformés.
          </p>
          <p className="footer__verse">
            "Car c'est par la grâce que vous êtes sauvés, par le moyen de la foi."
            <span>— Éphésiens 2:8</span>
          </p>
        </div>

        {/* Quick links */}
        <div className="footer__col">
          <h4 className="footer__col-title">Navigation</h4>
          <ul className="footer__list">
            {[
              ['/',           'Accueil'],
              ['/about',      'À Propos'],
              ['/events',     'Événements'],
              ['/sermons',    'Sermons'],
              ['/ministries', 'Ministères'],
              ['/gallery',    'Galerie'],
              ['/donation',   'Donner'],
              ['/contact',    'Contact'],
            ].map(([to, label]) => (
              <li key={to}><Link to={to}>{label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Service times */}
        <div className="footer__col">
          <h4 className="footer__col-title">Horaires de Culte</h4>
          <ul className="footer__list footer__list--times">
            <li><strong>Dimanche</strong><span>7h00 AM — École du Dimanche</span></li>
            <li><strong>Dimanche</strong><span>9h00 AM — Culte Principal</span></li>
            <li><strong>Mercredi</strong><span>6h00 PM — Combat Spirituel</span></li>
            <li><strong>Vendredi</strong><span>9h00 PM — Veillée de nuit</span></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer__col">
          <h4 className="footer__col-title">Contact</h4>
          <ul className="footer__list">
            <li>📍 Saint-Marc, Haïti</li>
            <li>📞 +509 3651-8509</li>
            <li>✉️ contact@miprecch.com</li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom container">
        <p>© {year} Première Église Chrétienne De La Chambre Haute De Saint-Marc — Tous droits réservés.</p>
        <p>
          Fait avec ❤️ pour la gloire de Dieu. &nbsp;|&nbsp; Conçu par{' '}
          <a
            href="https://next509.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__madeby-link"
          >
            Next509
          </a>
        </p>
      </div>
    </footer>
  );
}
